module.exports = __webpack_public_path__ + "img/546-42dfb3.png";